import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { FormationObligatoireReglementaire } from '../models/formation.model';
import { avecMéthodesFormations } from './for.methods';
import { initialState, FormationObligatoireReglementaireState } from './for.state';
import { withPagination } from '@shared/store/pagination.feature';

export const FormationReglementaireObligatoireStore = signalStore(
  { providedIn: 'root' },
  withState<FormationObligatoireReglementaireState>(initialState),
  withEntities<FormationObligatoireReglementaire>(),
  avecMéthodesFormations(),
  withPagination<FormationObligatoireReglementaire>(),
);
